import { useTranslation } from 'react-i18next'
import TextField from '@mui/material/TextField'
import Box from '@mui/system/Box'
import PropTypes from 'prop-types'

const classes = {
    disabledInput: {
        '& .Mui-disabled': {
            textFillColor: '#34495E',
        },
        '& .MuiInput-input.Mui-disabled': {
            textFillColor: '#34495E',
            fontWeight: 'bold',
        },
    },
}

const OrderCustomerContact = ({ order }) => {
    const { t } = useTranslation()

    const showCustomerName = Boolean(order.customerName) && order.customerName !== order.customerContact?.name

    return (
        <Box
            sx={{
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                display: 'flex',
                flexDirection: 'column',
                flexShrink: 0,
                gap: 2,
                justifyContent: 'space-between',
                width: 240,
            }}
        >
            {showCustomerName ? (
                <TextField
                    color="secondary"
                    label={t('Company/Business')}
                    size="small"
                    slotProps={{
                        input: {
                            disableUnderline: true,
                        },
                        htmlInput: {
                            'data-testid': 'order-customer-input',
                        },
                        inputLabel: {
                            shrink: true,
                        },
                    }}
                    sx={classes.disabledInput}
                    value={order?.customerName}
                    variant="standard"
                    disabled
                    fullWidth
                />
            ) : null}

            <TextField
                color="secondary"
                label={t('Customer name')}
                size="small"
                slotProps={{
                    input: {
                        disableUnderline: true,
                    },

                    htmlInput: {
                        'data-testid': 'order-contact-input',
                    },

                    inputLabel: {
                        shrink: true,
                    },
                }}
                sx={classes.disabledInput}
                value={order?.customerContact?.name}
                variant="standard"
                disabled
                fullWidth
            />
        </Box>
    )
}

OrderCustomerContact.propTypes = {
    order: PropTypes.object.isRequired,
}

export default OrderCustomerContact
